import { jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PaymentGroupName } from '@as-react/common-types';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { Text, TextColor } from '@as/cotopaxi';
export const getPaymentGroupImageUrl = (groupName, prefix) => {
    switch (groupName) {
        case 'kbc_online':
            return `${prefix}KBC_logo.svg`;
        case 'cbc_online':
            return `${prefix}CBC_logo.svg`;
        case 'maestro':
            return `${prefix}Maestro_logo.svg`;
        case 'paypal':
            return `${prefix}Paypal_logo.svg`;
        case 'ideal':
            return `${prefix}iDeal_logo.svg`;
        case 'bancontact_mistercash':
            return `${prefix}Bancontact_Mister_Cash_logo.svg`;
        case 'visa':
            return `${prefix}VISA_logo.svg`;
        case 'mastercard':
            return `${prefix}mastercard.svg`;
        case 'carte-bancaire-and-mastercard':
            return `${prefix}carte_bancaire_mastercard.png`;
        case 'American_Express_choice':
            return `${prefix}amex_logo.svg`;
        case 'ing_homepay':
            return `${prefix}ING_logo.svg`;
        case 'belfius-direct-net':
            return `${prefix}belfius_logo.svg`;
        case 'vvv':
            return `${prefix}vvv.png`;
        case 'visa_delta':
            return `${prefix}VISA_delta_logo.svg`;
        case 'carte_bleue':
            return `${prefix}carte_bleue.svg`;
        case 'rembours':
            return `${prefix}rembours.svg`;
        case 'afterpay':
            return `${prefix}afterpay.png`;
        case 'klarna':
            return `${prefix}klarna.png`;
        case 'sofort':
            return `${prefix}klarna_sofort.png`;
        case 'directtransfer':
            return `${prefix}sepa_lastschrift_logo.png`;
        case 'applepay':
            return `${prefix}applepay.png`;
        case 'googlepay':
            return `${prefix}googlepay.png`;
        case 'ecocheque_monizze':
            return `${prefix}ecocheque_monizze_logo.png`;
        case 'ecocheque_pluxee':
            return `${prefix}ecocheque_pluxee_logo.png`;
        case 'ecocheque_edenred':
            return `${prefix}ecocheque_edenred_logo.png`;
        default:
            return '';
    }
};
export const getAndesPaymentGroupImageUrl = (groupName, prefix) => {
    switch (groupName) {
        case 'maestro':
            return `${prefix}maestro.png`;
        case 'paypal':
            return `${prefix}paypal.png`;
        case 'ideal':
            return `${prefix}ideal.png`;
        case 'bancontact_mistercash':
            return `${prefix}bancontact.png`;
        case 'visa':
            return `${prefix}visa.png`;
        case 'mastercard':
            return `${prefix}mastercard.png`;
        case 'American_Express_choice':
            return `${prefix}amex.png`;
        case 'vvv':
            return `${prefix}vvv.png`;
        case 'visa_delta':
            return `${prefix}visa.png`;
        case 'klarna':
            return `${prefix}klarna.png`;
        case 'sofort':
            return `${prefix}klarna_sofort.png`;
        case 'applepay':
            return `${prefix}applepay.png`;
        case 'googlepay':
            return `${prefix}googlepay.png`;
        case 'ecocheque_monizze':
            return `${prefix}monizze.png`;
        case 'ecocheque_pluxee':
            return `${prefix}pluxee.png`;
        case 'ecocheque_edenred':
            return `${prefix}edenred.png`;
        default:
            return '';
    }
};
export const getGroupName = (group) => {
    switch (group.name) {
        case PaymentGroupName.CARTE_BLEUE:
            return 'carteblue';
        default:
            return group.name.toLowerCase().replace(/\s/g, '');
    }
};
export const getPaymentGroupTitle = (group, t) => {
    switch (group.name) {
        case PaymentGroupName.ECOCHEQUE:
            return (_jsxs(_Fragment, { children: [t(`${I18N_NAMESPACES.buy}:buy.payment.group.ecocheque`), ' ', _jsxs(Text, { color: TextColor.SUBTLE, inline: true, children: ["(", group.paymentOptions
                                .map(option => {
                                var _a;
                                return t(`${I18N_NAMESPACES.buy}:buy.payment.group.ecocheque.payment_option.${(_a = option.paymentMethodCode) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`);
                            })
                                .join(', '), ")"] })] }));
        default:
            return t(`${I18N_NAMESPACES.buy}:buy.payment.group.${getGroupName(group)}`);
    }
};
export const isAllPaymentOptionsValid = (group) => group.paymentOptions.every(option => { var _a; return !((_a = option.reasonNotValidForBasket) === null || _a === void 0 ? void 0 : _a.length) && !option.exceededMaxBasketCost; });
export const isSingleOption = (group) => group.paymentOptions.length === 1;
